export const FileManagerColumns = ({ showCheckboxes, showVersions }) => {
    return (
        <thead>
            <tr className="border-bottom">
                {showCheckboxes && <th className="w-10px ps-10px">Select</th>}
                <th className="w-10px ps-10px">Type</th>
                <th className="px-10px">Name</th>
                {showVersions && <th className="px-10px w-10px">Previous Versions</th>}
                <th className="px-10px w-100px">Size</th>
                <th className="px-10px w-200px">Created</th>
                <th className="px-10px w-200px">Last Modified</th>
            </tr>
        </thead>
    );
};